import { render, staticRenderFns } from "./RouterLinkToCardColumnTemplate.vue?vue&type=template&id=72b433f8"
import script from "./RouterLinkToCardColumnTemplate.vue?vue&type=script&lang=js"
export * from "./RouterLinkToCardColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./RouterLinkToCardColumnTemplate.vue?vue&type=style&index=0&id=72b433f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports